import { Component } from '@angular/core';
import { ElementBase } from "../element-base";

@Component({
  selector: 'app-element-date',
  templateUrl: './element-date.component.html',
  styleUrl: './element-date.component.scss'
})
export class ElementDateComponent extends ElementBase {

}
